import React from 'react'
import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { withRouter } from 'react-router-dom'
import secondary from 'material-ui/colors/orange'
import otherBlue from 'material-ui/colors/blue'
import grey from 'material-ui/colors/grey'

const primary = {
  50: '#e1eaf0',
  100: '#b4cad9',
  200: '#82a7c0',
  300: '#5084a6',
  400: '#2b6993',
  500: '#054f80',
  600: '#044878',
  700: '#043f6d',
  800: '#033663',
  900: '#012650',
  A100: '#83b1ff',
  A200: '#5092ff',
  A400: '#1d72ff',
  A700: '#0362ff',
  contrastDefaultColor: 'light',
}

const Theme = ({ enableDarkTheme, ...props }) => {
  const themeSettings = createMuiTheme({
    palette: {
      background: {
        default: enableDarkTheme ? '#303030' : grey[50],
      },
      primary: enableDarkTheme ? otherBlue : primary,
      secondary,
      type: enableDarkTheme ? 'dark' : 'light',
    },
    typography: {
      fontFamily: 'Roboto, sans-serif',
    },
    overrides: {
      MuiFormControl: {
        root: {
          marginBottom: 25,
        },
      },
    },
  })

  const Container = styled.div`
    height: 100%;
    width: 100%;
    font-family: ${themeSettings.typography.fontFamily};
  `
  return (
    <MuiThemeProvider theme={themeSettings}>
      <Container dark={enableDarkTheme} {...props} />
    </MuiThemeProvider>
  )
}

const mapStateToProps = state => ({
  enableDarkTheme: state.config.enableDarkTheme,
})

export default withRouter(connect(mapStateToProps)(Theme))



// WEBPACK FOOTER //
// ./src/components/Theme.js